import FinExperiencesPage from '@playground/features/dictionary/FinExperiencesPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/fin-experiences'
)({
  component: FinExperiencesPage,
})
